import React from 'react';
import { Select } from 'antd';
import { SelectContainer } from 'shared/styles';
import { useAppSelector } from 'shared/hooks';
import { Admin, EAdminRoles, School } from 'shared/types';

interface SchoolOption {
  id: string;
  name: string;
  data_source?: string;
}

type Props = {
  value: string;
  handleSchoolChange: (schoolId: string) => void;
  disabled: boolean;
  hideAllSchools?: boolean;
  schools?: SchoolOption[];
  placeholder?: string;
};

const SchoolSelect: React.FC<Props> = ({
  value,
  handleSchoolChange,
  disabled,
  hideAllSchools,
  schools: schoolsProp,
  placeholder,
}): JSX.Element => {
  const currentUser = useAppSelector((state): Admin | null => state.auth.user);
  const reduxSchools = useAppSelector((state): School[] => state.schools.allSchools);
  const schools: SchoolOption[] = schoolsProp || reduxSchools.map(s => ({
    id: s.id,
    name: s.name || s.Name,
    data_source: s.data_source
  }));
  const normalizedValue = value?.trim() ? value : hideAllSchools ? undefined : '';

  const productDSchools = schools.filter(s => s.data_source === 'product_d');
  const productCSchools = schools.filter(s => s.data_source === 'product_c');

  if (currentUser?.role !== EAdminRoles.SUPER_ADMIN) return <div />;

  return (
    <SelectContainer>
      <Select
        showSearch
        filterOption={(input, option) => {
          const label = typeof option?.children === 'string'
            ? option.children
            : String(option?.children ?? '');
          return label.toLowerCase().includes(input.toLowerCase());
        }}
        style={{
          width: '100%',
          marginBottom: '15px'
        }}
        onChange={handleSchoolChange}
        placeholder={placeholder ?? 'School'}
        value={normalizedValue}
        disabled={disabled}
      >
        {!hideAllSchools && (
          <Select.Option disabled={disabled} value={''}>
            {'All schools (default)'}
          </Select.Option>
        )}
        {productDSchools.map(
          (school): JSX.Element => (
            <Select.Option disabled={disabled} key={school.id} value={school.id}>
              {school.name} (product_d)
            </Select.Option>
          )
        )}
        <Select.Option disabled key='__divider__' value='__divider__' style={{ cursor: 'default', padding: 0, minHeight: 0 }}>
          <div style={{ borderTop: '1px solid #d9d9d9', margin: '4px 0' }} />
        </Select.Option>
        {productCSchools.map(
          (school): JSX.Element => (
            <Select.Option disabled={disabled} key={school.id} value={school.id}>
              {school.name} (product_c)
            </Select.Option>
          )
        )}
      </Select>
    </SelectContainer>
  );
};

export default SchoolSelect;
